import { store } from "@/store";
import {
  RequestableSaasDestination,
  SaaSDestination,
  saasDestinations,
} from "../destinations/destinations";
import {
  buildFunctionDestinationsLookup,
  useFunctionDestinations,
} from "./useFunctionDestinations";

export const useAllSaasDestinations = (): {
  [destSlug: string]: SaaSDestination | RequestableSaasDestination | undefined;
} => {
  const functionDestinations = useFunctionDestinations();
  return { ...saasDestinations, ...functionDestinations };
};

export function getAllSaasDestinations() {
  return {
    ...buildFunctionDestinationsLookup(
      store.getState().functionDefs.functionDefs || [],
    ),
    ...saasDestinations,
  };
}
